/**
 * Stable per-browser id for front-desk ticket threads when no employee
 * record is selected. Must match SupportDrawer so created tickets and
 * polling use the same key.
 */
export function getOrCreateSupportStaffId() {
  if (typeof window === 'undefined') return '';
  const key = 'supportStaffId';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const id = (window.crypto && typeof window.crypto.randomUUID === 'function')
      ? window.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(key, id);
    return id;
  } catch {
    return '';
  }
}
